/* 房源设置 */
<template>
  <div>
    <div class="warpper_top">
      <h1 class="warpper_top_title">房源设置</h1>
    </div>

    <div class="warpper_con">
      <a-form-model ref="dataInfo" :model="dataInfo" :rules="rules" layout="horizontal">
        <div class="disFlex line">
          <a-form-model-item class="mr50" colon label="房源类型" prop="rentSaleType">
            <a-select
              v-model="dataInfo.rentSaleType"
              class="w200"
              size="default"
              placeholder="请选择"
              @change="typeChangeFn"
            >
              <a-select-option v-for="t in rentSaleTypeOptions" :key="t.dictValue" :value="t.dictValue">{{
                t.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item class="mr50" colon label="房源状态" prop="houseStatus">
            <a-select
              v-model="dataInfo.houseStatus"
              class="w200"
              size="default"
              @change="statusChangeFn"
              placeholder="请选择"
            >
              <a-select-option v-for="t in houseStatusOptions" :key="t.dictValue" :value="t.dictValue * 1">{{
                t.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
        <h3 class="page_item_title">掉盘设置</h3>
        <div class="disFlex line">
          <a-form-model-item class="mr50" colon label="单店公共池" prop="shopPool">
            <!-- <a-input-number
              size="default"
              v-model="dataInfo.shopPool"
              :default-value="0"
              :min="0"
              :formatter="(value) => `${value}天`"
              :parser="(value) => value.replace('天', '')"
            /> -->
            <a-input :max-length="6" size="default" v-model="dataInfo.shopPool" suffix="天" />
          </a-form-model-item>
          <a-form-model-item class="mr50" colon label="公司公共池" prop="companyPool">
            <a-input :max-length="6" size="default" v-model="dataInfo.companyPool" suffix="天" />
          </a-form-model-item>
          <a-form-model-item class="mr50" colon label="掉盘提醒天数" prop="fallNotify">
            <a-input :max-length="6" size="default" v-model="dataInfo.fallNotify" suffix="天" />
          </a-form-model-item>
        </div>

        <h3 class="page_item_title">公转私</h3>
        <div class="disFlex line">
          <a-form-model-item class="mr50" colon label="最大认领次数" prop="receiveMaxNum">
            <a-input :max-length="6" size="default" v-model="dataInfo.receiveMaxNum" suffix="次/天" />
          </a-form-model-item>

          <a-form-model-item class="mr50" colon label="认领保护时长" prop="receiveLockTime">
            <a-input :max-length="6" size="default" v-model="dataInfo.receiveLockTime" suffix="小时" />
          </a-form-model-item>

          <a-form-model-item class="mr50" colon label="是否开启认领审批" prop="isOpenReceiveAudit">
            <a-select v-model="dataInfo.isOpenReceiveAudit" size="default" placeholder="请选择">
              <a-select-option v-for="s in openStatusOptions" :key="s.dictValue" :value="s.dictValue">{{
                s.dictLabel
              }}</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item class="mr50" colon label="认领释放时长" prop="receiveReleaseTime">
            <!-- <a-input-number
              size="default"
              v-model="dataInfo.receiveReleaseTime"
              :default-value="1"
              :min="1"
              :formatter="(value) => `${value}小时`"
              :parser="(value) => value.replace('小时', '')"
            /> -->
            <a-input :max-length="6" size="default" v-model="dataInfo.receiveReleaseTime" suffix="小时" />
          </a-form-model-item>
        </div>

        <h3 class="page_item_title">实勘</h3>
        <div class="disFlex line">
          <a-form-model-item class="mr50" colon label="保护时长" prop="fieldInvestigationProtectTime">
            <!-- <a-input-number
              size="default"
              v-model="dataInfo.fieldInvestigationProtectTime"
              :default-value="0"
              :min="0"
              :formatter="(value) => `${value}小时`"
              :parser="(value) => value.replace('小时', '')"
            /> -->
            <a-input :max-length="6" size="default" v-model="dataInfo.fieldInvestigationProtectTime" suffix="小时" />
          </a-form-model-item>
        </div>

        <h3 class="page_item_title">房源水印</h3>
        <div class="disFlex line">
          <a-form-model-item class="w200 mr50" colon label="" prop="housingResourceWatermarkUrl">
            <upload-cmp
              :img-url="fileInfo && fileInfo.fileName ? fileInfo.fileName : ''"
              type="image"
              @fileUrlFn="fileUrlFn"
            ></upload-cmp>
            <a-input v-show="1 === 2" v-model="dataInfo.housingResourceWatermarkUrl" placeholder="请输入" />
          </a-form-model-item>
        </div>
        <h3 class="page_item_title" style="margin-bottom: 20px">掉盘后保留人员类型</h3>
        <div class="line" style="margin-bottom: 20px; padding-bottom: 20px">
          <a-checkbox v-if="dataInfo.isAccendantPerson === 'Y'" checked @click="handleCheck('isAccendantPerson')">
            维护人
          </a-checkbox>
          <a-checkbox v-else @click="handleCheck('isAccendantPerson')"> 维护人 </a-checkbox>

          <a-checkbox v-if="dataInfo.isInputPerson === 'Y'" checked @click="handleCheck('isInputPerson')">
            录入人
          </a-checkbox>
          <a-checkbox v-else @click="handleCheck('isInputPerson')"> 录入人 </a-checkbox>

          <a-checkbox v-if="dataInfo.isKeyPerson === 'Y'" checked @click="handleCheck('isKeyPerson')">
            钥匙人
          </a-checkbox>
          <a-checkbox v-else @click="handleCheck('isKeyPerson')"> 钥匙人 </a-checkbox>

          <a-checkbox v-if="dataInfo.isPicturePerson === 'Y'" checked @click="handleCheck('isPicturePerson')">
            图片人
          </a-checkbox>
          <a-checkbox v-else @click="handleCheck('isPicturePerson')"> 图片人 </a-checkbox>
        </div>

        <h3 class="page_item_title" style="margin-bottom: 20px">默认业绩分配规则</h3>
        <div class="line" style="margin-bottom: 20px; padding-bottom: 20px">
          <div class="list_allot_rules">
            <div class="item_allot_rule" v-for="(rule, index) in dataInfo.allotRuleBoList" :key="'rule_' + index">
              <div class="personel_type">
                <a-form-model-item class="mr50" colon layout="inline" label="人员类型" :prop="'personnelType' + index">
                  <a-select disabled v-model="rule.personnelType" size="default" placeholder="请选择">
                    <a-select-option v-for="r in relatedPersonneTypeOpts" :key="r.dictValue" :value="r.dictValue">
                      {{ r.dictLabel }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
              </div>
              <div class="accept_role">
                <a-form-model-item class="mr50" colon label="接受业绩角色" :prop="'acceptPerformanceRole' + index">
                  <a-select v-model="rule.acceptPerformanceRole" size="default" placeholder="请选择">
                    <template v-for="r in relatedPersonneTypeOpts">
                      <a-select-option
                        :key="r.dictValue"
                        :value="r.dictValue"
                        v-if="r.dictValue !== rule.personnelType"
                      >
                        {{ r.dictLabel }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-model-item>
              </div>
              <div class="ratio_num">
                <a-form-model-item class="mr50" label="分配比例" :prop="'achievementsRatio' + index">
                  <a-input :max-length="11" size="default" v-model="rule.achievementsRatio" suffix="%" />
                </a-form-model-item>
              </div>
            </div>
          </div>
        </div>

        <h3 class="page_item_title">自定义标签</h3>
        <div class="disFlex line tags">
          <div class="item_tag dis_flex mr50" v-for="(tag, index) in dataInfo.tagBoList" :key="index">
            <a-form-model-item class="item_" label="" prop="tagName">
              <a-input :max-length="15" v-model="tag.tagName" placeholder="请输入" />
            </a-form-model-item>

            <a-button class="ml20 btn_elRt" type="link" @click="removeTag(tag, index)">
              <a-icon type="minus-circle" :style="{ fontSize: '24px', color: 'red' }" />
            </a-button>
          </div>

          <a-button type="link" @click="addTag">
            <a-icon type="plus-circle" :style="{ fontSize: '24px', color: 'var(--ThemeColor)' }" />
          </a-button>
        </div>

        <div class="disFlex btn_center">
          <a-button type="primary" @click="submitForm"> 保存 </a-button>
        </div>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import {
  houseResourceList,
  getHouseResource,
  addHouseResource,
  updateHouseResource,
  // delHouseResource,
  delHouseResTag
} from '@/api/setting/houseresource'
// import { delHouseResourceTag} from '@/api/setting/houseresourcetag'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { tableMixin } from '@/store/table-mixin'
import UploadCmp from '@/components/UploadCmp/index'

export default {
  name: 'Houseresource',
  components: {
    UploadCmp
  },
  mixins: [tableMixin],
  data () {
    return {
      curType: '', // 当前类型
      openStatusOptions: [],
      rentSaleTypeOptions: [],
      houseStatusOptions: [],
      relatedPersonneTypeOpts: [], // 相关人员类型 字典表类型：related_personne_type
      loading: false,
      submitLoading: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 14 }
      },
      keyId: undefined,
      curHouseStatus: '', // 房源状态
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        houseStatus: '1', // 上架
        rentSaleType: '1' // 1租2售
      },

      tagVoList: [],
      typePerson: [],
      // 相关人员类型：related_personne_type 1= 录入人	2=维护人	3=钥匙人	4=图片人	5=搭档	6=客源
      allotRuleBoList: [
        {
          acceptPerformanceRole: undefined, //	接收业绩角色		true
          achievementsRatio: undefined, //	比例分配		true
          id: undefined, //	id，新增时不传，修改时必传		true
          personnelType: '1', //	人员类型true
          housingSetId: this.keyId, //	房源设置ID
          rentSaleType: this.curType, //	租售类型
          houseStatus: this.curHouseStatus // 房源状态
        },
        {
          acceptPerformanceRole: undefined, //	接收业绩角色		true
          achievementsRatio: undefined, //	比例分配		true
          id: undefined, //	id，新增时不传，修改时必传		true
          personnelType: '2', //	人员类型true
          housingSetId: this.keyId, //	房源设置ID
          rentSaleType: this.curType, //	租售类型
          houseStatus: this.curHouseStatus // 房源状态
        },
        {
          acceptPerformanceRole: undefined, //	接收业绩角色		true
          achievementsRatio: undefined, //	比例分配		true
          id: undefined, //	id，新增时不传，修改时必传		true
          personnelType: '3', //	人员类型true
          housingSetId: this.keyId, //	房源设置ID
          rentSaleType: this.curType, //	租售类型
          houseStatus: this.curHouseStatus // 房源状态
        },
        {
          acceptPerformanceRole: undefined, //	接收业绩角色		true
          achievementsRatio: undefined, //	比例分配		true
          id: undefined, //	id，新增时不传，修改时必传		true
          personnelType: '4', //	人员类型true
          housingSetId: this.keyId, //	房源设置ID
          rentSaleType: this.curType, //	租售类型
          houseStatus: this.curHouseStatus // 房源状态
        }
      ], // 业绩分配规则List
      dataInfo: {
        rentSaleType: undefined, // 租售类型 字典表类型：rent_sale_type
        companyPool: undefined, // 公司公共池
        houseStatus: undefined, // 房源状态
        fallNotify: undefined, // 掉盘提醒天数（天）
        fieldInvestigationProtectTime: undefined, // 实勘保护时长（小时）
        housingResourceWatermarkUrl: undefined, // 房源水印url
        id: undefined, // 新增时不传，修改时必传
        isOpenReceiveAudit: undefined, // 是否开启认领审批
        receiveLockTime: undefined, // 认领锁定时长（小时）
        receiveMaxNum: undefined, // 最大认领次数（次/天）
        receiveReleaseTime: undefined, //	认领释放时长（小时）
        shopPool: undefined, // 单店公共池
        allotRuleBoList: this.allotRuleBoList, // 业绩分配规则List
        housingResourceWatermarkUrlList: [
          {
            createBy: undefined, // 创建者
            createTime: undefined, // 创建时间
            fileName: undefined, //
            fileSuffix: undefined, //
            originalName: undefined, //
            ossId: undefined, //	integer
            params: undefined, //	请求参数	object
            searchValue: undefined, // 搜索值	string
            service: undefined, //	string
            updateBy: undefined, // 更新者	string
            updateTime: undefined, // 更新时间	string
            url: undefined //
          }
        ],
        tagBoList: [],
        allotRuleVoList: [],
        isAccendantPerson: 'N', // 维护人
        isInputPerson: 'N', // 录入人
        isKeyPerson: 'N', // 钥匙人
        isPicturePerson: 'N' // 图片人
      },
      fileInfo: {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      },
      rules: {
        rentSaleType: [{ required: true, message: '必选', trigger: 'blur' }],
        houseStatus: [{ required: true, message: '必选', trigger: 'blur' }],
        shopPool: [{ required: true, pattern: /^[0-9]+$/, message: '格式错误', trigger: 'blur' }],
        companyPool: [{ required: true, pattern: /^[0-9]+$/, message: '格式错误', trigger: 'blur' }],
        fallNotify: [{ required: true, pattern: /^[0-9]+$/, message: '格式错误', trigger: 'blur' }],
        receiveMaxNum: [{ required: true, pattern: /^[0-9]+$/, message: '格式错误', trigger: 'blur' }],
        receiveLockTime: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        receiveReleaseTime: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        fieldInvestigationProtectTime: [
          {
            required: true,
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          }
        ],
        isAccendantPerson: [{ required: true, message: '必选', trigger: 'blur' }],
        isInputPerson: [{ required: true, message: '必选', trigger: 'blur' }],
        isKeyPerson: [{ required: true, message: '必选', trigger: 'blur' }],
        isPicturePerson: [{ required: true, message: '必选', trigger: 'blur' }],
        // housingResourceWatermarkUrl: [{ required: true, message: '必填', trigger: 'blur' }],
        isOpenReceiveAudit: [{ required: true, message: '必选', trigger: 'blur' }]
      },
      headers: {
        Authorization: 'Bearer ' + storage.get(ACCESS_TOKEN),
        Accept: 'application/json, text/plain, */*' // multipart/form-data
      },
      columns: []
    }
  },
  filters: {},
  created () {
    // 是否开启
    this.getDicts('sys_yes_no').then((response) => {
      this.openStatusOptions = response.data
    })
    // 租售类型 字典表类型：rent_sale_type
    this.getDicts('rent_sale_type').then((response) => {
      this.rentSaleTypeOptions = response.data
      // console.log(this.rentSaleTypeOptions)
    })
    // 获取房源状态
    this.getDicts('house_status').then((response) => {
      this.houseStatusOptions = response.data
    })
    // 相关人员类型 字典表类型：related_personne_type
    this.getDicts('related_personne_type').then((response) => {
      // 相关人员类型：related_personne_type 1= 录入人	2=维护人	3=钥匙人	4=图片人	5=搭档	6=客源
      this.relatedPersonneTypeOpts = response.data.filter((item) => {
        return (
          item.dictLabel === '录入人' ||
          item.dictLabel === '维护人' ||
          item.dictLabel === '钥匙人' ||
          item.dictLabel === '实勘人'
        )
      })
    })
    this.getList()
  },
  computed: {},
  watch: {},
  methods: {
    // 房源状态改变
    statusChangeFn (e) {
      this.curHouseStatus = e
      this.queryParam.houseStatus = e
      this.getList()
    },
    // 房源类型改变重新请求列表
    typeChangeFn (e) {
      // console.log(e)
      this.curType = e
      this.queryParam.rentSaleType = e
      this.getList()
    },
    // 人员类别
    handleCheck (key) {
      this.dataInfo[key] = this.dataInfo[key] === 'Y' ? 'N' : 'Y'
    },
    initData () {
      this.tagVoList = []
      this.dataInfo = {
        rentSaleType: undefined, //
        houseStatus: undefined, // 房源状态
        companyPool: undefined, // 公司公共池
        fallNotify: undefined, // 掉盘提醒天数（天）
        fieldInvestigationProtectTime: undefined, // 实勘保护时长（小时）
        housingResourceWatermarkUrl: undefined, // 房源水印url
        id: undefined, // 新增时不传，修改时必传
        isOpenReceiveAudit: undefined, // 是否开启认领审批
        receiveLockTime: undefined, // 认领锁定时长（小时）
        receiveMaxNum: undefined, // 最大认领次数（次/天）
        receiveReleaseTime: undefined, //	认领释放时长（小时）
        shopPool: undefined, // 单店公共池
        tagBoList: [],
        allotRuleBoList: this.allotRuleBoList, // 业绩分配规则List
        isAccendantPerson: 'N', // 维护人
        isInputPerson: 'N', // 录入人
        isKeyPerson: 'N', // 钥匙人
        isPicturePerson: 'N' // 图片人
      }
      this.fileInfo = {
        createBy: '',
        createTime: '',
        fileName: '',
        fileSuffix: '',
        originalName: '',
        ossId: undefined,
        service: 'huawei',
        url: ''
      }
    },
    /** 查询房源信息列表 */
    getList () {
      this.loading = true
      houseResourceList(this.queryParam).then((response) => {
        if (response.code === 200) {
          const resData = response.data
          this.initData()
          if (resData != null && resData.length > 0) {
            const dataObj = resData[0]
            this.dataInfo = dataObj

            const _list = dataObj.tagVoList
            if (_list != null && _list.length > 0) {
              this.tagVoList = JSON.parse(JSON.stringify(_list))
              this.dataInfo.tagBoList = JSON.parse(JSON.stringify(_list))
            } else {
              this.tagVoList = []
              this.dataInfo.tagBoList = []
            }
            const ruleList = dataObj.allotRuleVoList
            if (ruleList != null && ruleList.length > 0) {
              this.allotRuleBoList = JSON.parse(JSON.stringify(ruleList))
              this.dataInfo.allotRuleBoList = this.allotRuleBoList
            } else {
              this.allotRuleBoList = [
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '1', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                },
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '2', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                },
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '3', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                },
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '4', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                }
              ]
              this.dataInfo.allotRuleBoList = this.allotRuleBoList
            }

            this.keyId = dataObj.id

            const fileObj = this.dataInfo.housingResourceWatermarkUrlList[0]
            this.fileInfo = fileObj
            this.curType = this.dataInfo.rentSaleType
          } else {
            this.dataInfo.rentSaleType = this.curType
            this.dataInfo.houseStatus = this.curHouseStatus
            this.keyId = undefined
            this.allotRuleBoList = [
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '1', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                },
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '2', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                },
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '3', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                },
                {
                  acceptPerformanceRole: undefined, //	接收业绩角色		true
                  achievementsRatio: undefined, //	比例分配		true
                  id: undefined, //	id，新增时不传，修改时必传		true
                  personnelType: '4', //	人员类型true
                  housingSetId: this.keyId, //	房源设置ID
                  rentSaleType: this.curType, //	租售类型
                  houseStatus: this.curHouseStatus // 房源状态
                }
              ]
              this.dataInfo.allotRuleBoList = this.allotRuleBoList
          }
        }
        this.loading = false
      })
    },
    // 验证业绩分配规则
    validateRules () {
      const list_ = this.dataInfo.allotRuleBoList
      let flag = true
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/
      let totalRatio = 0.0
      for (const obj of list_) {
        // const role_ = obj.acceptPerformanceRole// 接受业绩分配
        const ratio_ = obj.achievementsRatio // 比例分配
        const personnelType = obj.personnelType // 人员类型
        if (personnelType === null || personnelType === '' || typeof personnelType === 'undefined') {
          this.$message.error('人员类型必选', 3)
          flag = flag && false
          return false
        } else if (ratio_ === null || ratio_ === '' || typeof ratio_ === 'undefined') {
          this.$message.error('比例分配必填', 3)
          flag = flag && false
          return false
        } else if (!reg.test(ratio_)) {
          this.$message.error('比例分配数据格式错误', 3)
          flag = flag && false
          return false
        } else if (parseFloat(ratio_) > 100) {
          this.$message.error('比例分配数据不可超过100%', 3)
          flag = flag && false
          return false
        } else {
          totalRatio += parseFloat(ratio_)
          flag = flag && true
          continue
        }
      }
      if (totalRatio > 100) {
        this.$message.error('总的比例分配数据不可超过100%', 3)
        flag = flag && false
      } else {
        flag = flag && true
      }
      return flag
    },
    // 保存
    submitForm () {
      if (!this.validateRules()) {
        return
      }

      this.$refs.dataInfo.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          this.dataInfo.tagVoList = null
          if (this.dataInfo.id !== undefined) {
            updateHouseResource(this.dataInfo)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            addHouseResource(this.dataInfo)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                // 获取详情信息
                this.getList()
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
    getDetail () {
      const houseResourceId = this.dataInfo.id
      getHouseResource(houseResourceId).then((response) => {
        console.log('详情数,据', response.data)
        this.dataInfo = response.data
      })
    },

    fileUrlFn (file) {
      this.dataInfo.housingResourceWatermarkUrl = file.ossId + ''
      this.fileInfo = file
    },

    addTag () {
      const obj = {
        housingSetId: this.keyId, // 房源设置ID
        id: undefined,
        tagName: undefined // 标签名
      }
      console.log(this.tagVoList)
      this.tagVoList.push(obj)
      this.dataInfo.tagBoList.push(obj)
      this.$forceUpdate()
    },
    removeTag (row, idx) {
      const id = row.id
      if (id) {
        this.deleteHouseResTag(row)
      }
      this.dataInfo.tagBoList.splice(idx, 1)
      this.tagVoList.splice(idx, 1)
      this.$forceUpdate()
    },
    deleteHouseResTag (row) {
      var that = this
      const tagId = row.id
      if (tagId) {
        this.$confirm({
          title: '确认删除所选中数据?',
          content: '标签名称【' + row.tagName + '】的数据',
          onOk () {
            return delHouseResTag(tagId).then(() => {
              that.getList()
              that.$message.success('删除成功', 3)
            })
          },
          onCancel () {}
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
@titleFontSize: 20px;
@titleColor: #222;
@bodyFont: 14px;
@bodyColor: #666;
@tagFont: 12px;
@tagColor: #ddd;
.w200 {
  width: 200px;
}
.list_allot_rules {
  width: 100%;
  height: auto;
  .item_allot_rule {
    width: 100%;
    height: auto;
    display: flex;
  }
}

.btn_center {
  height: 100px;
  justify-content: center;
  align-items: center;
}
img {
  /* width:160px;
   height:122px; */
  object-fit: cover;
}
.warpper_top {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.warpper_top,
.warpper_con {
  background: #fff;
  padding: 20px;
}
.warpper_con {
  margin-top: 10px;
}
.page_item_title {
  font-size: 16px;
  color: @titleColor;
  font-weight: bold;
}
.warpper_top_title {
  font-size: @titleFontSize;
  color: @titleColor;
  font-weight: bold;
}
.item_tag {
  position: relative;
}
.btn_elRt {
  width: 30px;
  height: 30px;
  position: absolute;
  right: -5px;
  top: -10px;
  z-index: 9;
}
.tags {
  flex-wrap: wrap;
}
.line {
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 20px;
}
</style>
